import { Dispatch } from '../../../store/store';

export const mapDispatch = (dispatch: Dispatch) => ({
  setSearchCycleQuery: dispatch.cycles.setSearchCycleQuery,
});
